import { useEffect, useState } from "react";
import { Button, Modal, ModalBody } from "reactstrap";
import { toast } from "react-toastify";

import GeneralForm from "components/GeneralForm";
import { validate } from "components/validateGeneralForm";
import { confirm } from "components/Confirmation";
import { hideLoading, showLoading } from "components/Loading";
import ordemServicoService, { prioridadesOrdemServicoList } from "services/OrdemServicoService";
import { erroInesperado } from "services/Utils";

// SDD 037 - nao permite voltar para "sem prioridade"
const opcoesPrioridade = prioridadesOrdemServicoList.map(p => ({ value: p, label: p }))

export default function ModalAlterarPrioridade({ config, onClosed, onChange }) {
  const [data, setData] = useState({})

  useEffect(() => {
    if (!config) return

    const atual = opcoesPrioridade.some(el => el.value == config.prioridade) ? config.prioridade : null
    setData({ prioridade: atual })
  }, [config])

  const formConfig = [
    [
      {
        name: "prioridade",
        label: "Prioridade",
        type: "combo",
        required: true,
        colspan: 12,
        // so mostra o placeholder quando a OS ainda esta sem prioridade (obriga escolher uma)
        showDefault: !config?.prioridade,
        options: opcoesPrioridade,
      },
    ],
  ]

  const handleChange = (field, value) => {
    setData({ ...data, [field]: value })
  }

  const handleSubmit = (ev) => {
    ev.preventDefault()

    const errors = validate(formConfig, data)
    if (errors.length > 0) {
      setData({ ...data, errors })
      return
    }

    confirm({
      header: "Alterar Prioridade",
      text: "A previsão de início será recalculada com a regra da nova prioridade. Deseja continuar?",
      icon: "bi-exclamation-triangle",
      onConfirm: async () => {
        try {
          showLoading()
          const res = await ordemServicoService.alterarPrioridade(config.idOrdemServico, data.prioridade)
          hideLoading()
          if (res.success) {
            toast("A prioridade da Ordem de Serviço foi alterada com sucesso!")
            onChange && onChange()
            onClosed && onClosed()
          } else {
            toast("Erro ao alterar a prioridade da Ordem de Serviço")
          }
        } catch (ex) {
          hideLoading()
          const status = ex?.response?.status
          if ([400, 403, 404, 422].includes(status)) {
            toast(ex.response.data?.message || "Erro ao alterar a prioridade da Ordem de Serviço")
          } else {
            erroInesperado()
          }
        }
      }
    })
  }

  return (
    <Modal isOpen={!!config} onClosed={onClosed}>
      <ModalBody>
        <h2>Alterar Prioridade</h2>
        <hr />
        {config && (
          <form onSubmit={handleSubmit}>
            <GeneralForm
              config={formConfig}
              data={data}
              onChange={handleChange}
            />

            <div className="row mt-3">
              <div className="col-12 text-right">
                <Button color="primary" type="submit">Salvar</Button>
                <Button color="primary" onClick={onClosed} outline>Cancelar</Button>
              </div>
            </div>
          </form>
        )}
      </ModalBody>
    </Modal>
  )
}
